/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import {
  TYPE_APARTMENT,
  TYPE_COMMERCIAL_PREMISE,
  TYPE_HOUSE,
  TYPE_OFFICE,
  TYPE_TERRAIN
} from '../enums/EstateTypeCodes.mjs'

/**
 * Checks if it is a building estate (apartment, house...).
 * @param {string} estateType
 * @return {boolean}
 */
export function isBuildingEstate (estateType) {
  return [
    TYPE_APARTMENT,
    TYPE_OFFICE,
    TYPE_HOUSE,
    TYPE_COMMERCIAL_PREMISE
  ].indexOf(estateType) !== -1
}

/**
 * Checks if it is a physical estate.
 * @param {string} estateType
 * @return {boolean}
 */
export function isPhysicalEstate (estateType) {
  return [
    TYPE_APARTMENT,
    TYPE_OFFICE,
    TYPE_HOUSE,
    TYPE_COMMERCIAL_PREMISE,
    TYPE_TERRAIN
  ].indexOf(estateType) !== -1
}
